export const renderLanguage = ({ language = 'en-US', object = {} }) => {
  if (language in object) return object[language];

  if ('en-US' in object) return object['en-US'];

  return null;
};
